<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <!--------------------------------------------------------------------------------------->
      <label *ngIf="selected == null">Nothing selected!</label>
      <div *ngIf="selected!=null">
        <div *ngIf="showView">
          <div class="sidebar header-spacing"></div>
          <nb-card>
            <nb-card-body>
              <div class="row">
                <div class="col-4">
                  Responsible
                </div>
                <div class="col-8">
                  {{$any(selected?.manager)?.title}}
                </div>
              </div>
            </nb-card-body>
          </nb-card>

          <ng-container *ngFor="let contact of selected?.contacts">
            <nb-card *ngIf="contact.type !== 7">
              <nb-card-header>
                <h3>{{contact.title}}</h3>
              </nb-card-header>
              <nb-card-body>
                <button class="nrk-button mb-2" *ngIf="+contact.type == 5" (click)="makeExEmployee(contact)">Make Ex Employee</button>
                <div *ngFor="let field of contact.fields">
                  <ngx-form-entry [title]="FieldType[field.type]" [value]="field.value"></ngx-form-entry>
                </div>
              </nb-card-body>
              <hr>
            </nb-card>
          </ng-container>

          <div class="sidebar header-spacing"></div>
          <div class="sidebar header">
            <h1> {{selected.name || 'Create new business'}}</h1>
          </div>
          <div class="sidebar footer">
            <div class="row">
              <div class="mx-auto">
                <button class="btn btn-default btn-sm" (click)="cancel(selected)">Back</button>
              </div>
            </div>
          </div>
        </div>
        <!--------------------------------------------------------------------------------------->
        <div *ngIf="showDetail">
          <div class="sidebar header-spacing"></div>
          <label *ngIf="selected?.projects?.length == 0">No projects found!</label>
          <div *ngFor="let project of filterProjects(selected.projects)">
            <nb-card *ngIf="project.summary != null && project.summary.length > 0">
              <nb-card-header>
                <div class="row">
                  <div class="col-6">
                    <h4>{{project.name}}</h4>
                  </div>
                  <div class="col-6 text-right">
                    <p>{{ProjectStatus[project.status]}}</p>
                  </div>
                </div>

                <hr *ngIf="project.probability != null || project.potential != null">
                <div class="row" *ngIf="project.probability != null || project.potential != null">
                  <div class="col-4">
                    <div *ngIf="project.probability != null">
                      Probability {{project.probability?.toLocaleString('en-US', {minimumFractionDigits: 2})}}%&nbsp;<i class="ion-arrow-right-a"></i>&nbsp;{{project.firstPo | date:'MMM dd, yyyy'}}
                      <nb-progress-bar status="danger" [value]="project.probability"></nb-progress-bar>
                      <!--<ngb-rating max="5" [readonly]="true" [(rate)]="project.probability"></ngb-rating><br>-->
                    </div>
                  </div>
                  <div class="col-8" *ngIf="project.potential != null">
                    {{project.potential?.toLocaleString('en-US', {minimumFractionDigits: 2})}} EUR pa
                    <nb-progress-bar [value]="project.potential / potentialRange * 100"></nb-progress-bar>

                  </div>

                  <div class="col-3 text-right">

                  </div>
                </div>
                <hr>
              </nb-card-header>
              <nb-card-body>
                <table class="table table-hover" *ngIf="project.summary != null && project.summary.length > 0">
                  <tr><th>Type</th><th>Date</th><th>User</th><th>Location</th><th>Topic / Title</th><th>Description / Summary</th></tr>
                  <tr *ngFor="let projectDetail of project.summary" (click)="showNews(projectDetail._id, 'summary/' + selected._id)">
                    <td>
                      {{ContentType[projectDetail.type]}}
                    </td>
                    <td>
                      {{projectDetail.date | date:'MMM dd, yyyy' }}
                    </td>
                    <td>
                      {{projectDetail.owner}}
                    </td>
                    <td>
                      {{projectDetail.location}}
                    </td>
                    <td>
                      {{(projectDetail.title != null && projectDetail.title.length>60) ? (projectDetail.title | slice:0:60)+'..':(projectDetail.title)}}
                    </td>
                    <td>
                      {{(projectDetail.summary != null && projectDetail.summary.length>60) ? (projectDetail.summary | slice:0:60)+'..':(projectDetail.summary)}}
                    </td>
                  </tr>
                </table>
                <label *ngIf="project.summary == null || project.summary.length == 0">No entries found!</label>
              </nb-card-body>
              <nb-card-footer>

              </nb-card-footer>
            </nb-card>
          </div>

          <div class="sidebar header-spacing"></div>
          <div class="sidebar header">
            <h1> {{selected.name || 'Create new business'}}</h1>
          </div>
          <div class="sidebar footer">
            <div class="row">
              <div class="mx-auto">
                <button class="btn btn-default btn-sm" (click)="cancel(selected)">Back</button>
              </div>
            </div>
          </div>
        </div>
        <!--------------------------------------------------------------------------------------->
        <div *ngIf="showEdit">
          <ngx-business-edit [item]="selected" [general]="general" [isSaving]="isSaving" (save)="save($event)" (cancel)="cancel($event)"></ngx-business-edit>
        </div>
        <!--------------------------------------------------------------------------------------->
        <div *ngIf="showProject">
          <div class="sidebar header-spacing"></div>
          <nb-card>
            <nb-card-header><h4>General Contact</h4></nb-card-header>
            <nb-card-body>
              <ngx-form-list-contact-entry-preview [value]="general"></ngx-form-list-contact-entry-preview>
              <div class="row">
                <div class="col-4"><label>RSM</label></div>
                <div class="col-8">{{$any(selected?.manager)?.title}}</div>
              </div>
            </nb-card-body>
          </nb-card>


          <ngx-form-list-project [(projects)]="selected.projects"></ngx-form-list-project>

          <div class="sidebar header-spacing"></div>
          <div class="sidebar header">
            <h1> {{selected.name || 'Create new business'}}</h1>
          </div>
          <div class="sidebar footer">
            <div class="row">
              <div class="mx-auto">
                <button class="btn btn-default btn-sm" (click)="cancel(selected)">Back</button>
                <button class="btn btn-primary btn-sm" (click)="save(selected)">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--------------------------------------------------------------------------------------->
      <div *ngIf="showActivities">
        <div class="sidebar header-spacing"></div>
        <nb-card>
          <nb-card-header>
            <h4>Activities</h4>
            <ngx-search [(value)]="searchActivities"></ngx-search>
          </nb-card-header>
          <nb-card-body>
            <label *ngIf="selected?.activities?.length == 0">No activities found!</label>

            <table class="table table-hover" *ngIf="selected?.activities!= null && selected?.activities?.length > 0">
              <tr><th>Type</th><th>Date</th><th>User</th><th>Location</th><th>Topic / Title</th><th>Description / Summary</th></tr>
              <tr *ngFor="let activity of filterActivities(searchActivities, selected)" (click)="showNews(activity._id, 'activities/' + selected._id)">
                <td>
                  {{ContentType[activity.content?.type]}}
                </td>
                <td>
                  {{activity.date | date:'dd. MM. yyyy' }}
                </td>
                <td>
                  {{activity.owner.name}}
                </td>
                <td>
                  {{activity.location}}
                </td>
                <td>
                  {{(activity.title != null && activity.title.length>60) ? (activity.title | slice:0:60)+'..':(activity.title)}}
                </td>
                <td>
                  {{(activity.purpose != null && activity.purpose.length>60) ? (activity.purpose | slice:0:60)+'..':(activity.purpose)}}
                </td>
              </tr>
            </table>

          </nb-card-body>
        </nb-card>


        <div class="sidebar header-spacing"></div>
        <div class="sidebar header">
          <h1> {{selected?.name || 'Create new business'}}</h1>
        </div>
        <div class="sidebar footer">
          <div class="row">
            <div class="mx-auto">
            <button class="btn btn-default btn-sm" (click)="cancel(selected)">Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>
      <button class="btn btn-primary btn-lg pull-right" (click)="create()">+</button>
      <button class="btn btn-default btn-lg pull-right" (click)="refresh()"><i class="nb-loop"></i></button>
      <!-- <label><input type="checkbox" class="pull-right" [(ngModel)]="showDisabled" />show disabled items</label> -->
      <label *ngIf="auth.user?.admin" class="pull-right" style="margin-top:-9px">
        <div style="color:darkgray">show disabled</div>
        <ui-switch style="margin-left:15px" color="#c89712" [(ngModel)]="showDisabled"></ui-switch>
      </label>

      <h1>Business</h1>
      <ngx-search [(value)]="search"></ngx-search>
      <a [routerLink]="[]" (click)="downloadXlsx()" *ngIf="auth.user?.admin">Generate XLSX</a><br>
      <a [routerLink]="[]" (click)="downloadXlsx(true)" *ngIf="auth.user?.admin">Generate XLSX (Extended)</a><br>
      <a [routerLink]="[]" (click)="downloadXlsx(false, true)" *ngIf="auth.user?.admin">Generate XLSX (General Info Overview)</a><br>

      <!--<ss-multiselect-dropdown [options]="filterNameOptions" [texts]="filterNameText"  [settings]="FILTER_SEARCH" [(ngModel)]="filter.name"></ss-multiselect-dropdown>
      <ss-multiselect-dropdown [options]="filterStatusOptions" [texts]="filterStatusText" [settings]="FILTER_STANDARD" [(ngModel)]="filter.status"></ss-multiselect-dropdown>
      <ss-multiselect-dropdown [options]="filterDateOptions" [texts]="filterDateText" [settings]="FILTER_STANDARD" [(ngModel)]="filter.date"></ss-multiselect-dropdown>
      -->

      <div style="margin-top:-1em"><pagination-controls (pageChange)="p = $event"></pagination-controls></div>

      <table class="table table-hover">
        <thead>
        <tr>
          <th scope="col">Company</th>
          <th scope="col">Region</th>
          <th scope="col">Type</th>
          <th scope="col">Status</th>
          <!--<th scope="col">Last Updated</th>-->
          <th scope="col" class="small-width">Details</th>
          <th class="small-width"></th>
        </tr>
        </thead>
        <tbody>

        <tr *ngFor="let item of filter(search, data.businessesWithDisabled) | paginate: { itemsPerPage: 10, currentPage: p }"
            [ngClass]="{'table-active': item === selected}"
            (click)="select(item)">
          <td>{{item.name}}</td>
          <td>{{$any(item)?.region?.name}}</td>
          <td>{{BusinessType[item.type]}}</td>
          <td>{{item.active ? "Enabled" : "Disabled"}}</td>
          <!--<td>{{item.updatedAt  | date: 'dd. MM. yyyy'}}</td>-->
          <td class="small-width"><ngx-form-list-contact-entry-preview [popup]="true" [value]="getGeneralContact(item)"></ngx-form-list-contact-entry-preview></td>
          <td class="text-right small-width">
            <button class="btn btn-default btn-md" (click)="toggleSidebarView(item)"><i class="ion-android-globe"></i></button>
            <button class="btn btn-default btn-md" (click)="toggleSidebarDetail(item)"><i class="ion-android-checkmark-circle"></i></button>
            <button class="btn btn-default btn-md" (click)="toggleSidebarActivities(item)"><i class="ion-android-list"></i></button>
            <button class="btn btn-default btn-md" (click)="toggleSidebarProject(item)"><i class="ion-clipboard"></i></button>
            <button class="btn btn-default btn-md" (click)="toggleSidebar(item)"><i class="ion-android-contacts"></i></button>
            <!--
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-default btn-tn btn-dropdown noarrow" type="button" ngbDropdownToggle>
                <i class="ion-more"></i>
              </button>
              <ul class="nrk-dropdown-menu" ngbDropdownMenu>
                <li class="dropdown-item" (click)="toggleSidebar(item)"><i class="ion-edit"></i>&nbsp;Bearbeiten</li>
                <! --<li class="dropdown-item" (click)="remove(item)"><i class="ion-trash-a"></i>&nbsp;Löschen</li>- ->
                <li class="dropdown-item" (click)="toggleActive(item)"><i class="ion-flag"></i>&nbsp;{{ !item.active?"Aktiv":"Inaktiv"}} setzen</li>
              </ul>
            </div>-->
          </td>
        </tr>
        </tbody>
      </table>
    </ngx-page-container>
  </div>
</ng-sidebar-container>